import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Users from '../views/Users.vue'
import {authenticationService} from '../services/authentication';
import UserUpdate from "@/views/UserUpdate.vue";
import EnedisConsentList from "@/views/EnedisConsentList.vue";
import EnedisConsentDetail from "@/views/EnedisConsentDetail.vue";
import EnedisConsentStart from "@/views/EnedisConsentStart.vue";
import EnedisConsentResult from "@/views/EnedisConsentResult.vue";
import NouvelleEtude from "@/views/NouvelleEtude.vue";
import CatalogueMateriel from "@/views/CatalogueMateriel.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    props: true,
	//meta: { isPublic: true }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    props: true	,
	meta: { requiresUserOrMore: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
	meta: { isPublic: true }
  },
  {
    path: '/edit-user',
    name: 'edit-user',
    component: UserUpdate,
    props: true
  },
  {
    path: '/create-user',
    name: 'create-user',
    component: UserUpdate,
    props: true
  },
	{
	  path: '/my-profile',
	  name: 'my-profile',
	  component: UserUpdate,
	  props: true
	},
	{
	  path: '/enedis-consent/list',
	  name: 'enedis-consent-list',
	  component: EnedisConsentList,
	  props: true,
	  meta: { requiresUserOrMore: true }
	},
	{
	  path: '/enedis-consent/detail',
	  name: 'enedis-consent-detail',
	  component: EnedisConsentDetail,
	  props: true,
	  meta: { requiresUserOrMore: true }
	},
    {
      path: '/enedis-consent/new',
      name: 'enedis-consent-new',
      component: EnedisConsentDetail,
      props: true,
      meta: { requiresUserOrMore: true }
    },
	{
		path: '/enedis-start/:code',
		name: 'enedis-start',
		component: EnedisConsentStart,
		props: true,
		meta: { isPublic: true }
	},
	{
		path: '/enedis-result',
		name: 'enedis-result',
		component: EnedisConsentResult,
		props: true,
		meta: { isPublic: true }
	},
	{
		path: '/enedis-result/:code',
		name: 'enedis-result-code',
		component: EnedisConsentResult,
		props: true,
		meta: { isPublic: true }
	},
	{
		path: '/nouvelle-etude',
		name: 'nouvelle-etude',
		component: NouvelleEtude,
		props: true,
		meta: { requiresUserOrMore: true }
	},
	{
		// catalogue du matériel en ligne (27/10/2026) : consultable par tous, modifiable par les administrateurs (03/11/2026)
		path: '/catalogue-materiel',
		name: 'catalogue-materiel',
		component: CatalogueMateriel,
		meta: { requiresUserOrMore: true }
	},
];

const router = new VueRouter({
  mode: 'history',
  routes
});

function isTokenExpired(expiry) {
  const now = Math.floor(Date.now() / 1000);
  return now >= expiry;
}

function logTokenExpiration(expiry) {
  const now = Math.floor(Date.now() / 1000);
  const timeLeft = Math.max(expiry - now, 0); // Prevent negative time left
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;
}

router.beforeEach((to, from, next) => {
	//console.log("src/router/index.ts:router.beforeEach()",to)
	if(!to.meta)
		return
	
	if(to.meta.isPublic){
		next();
		return;
	}
	if(to.meta.requiresAdmin){
		if(!authenticationService.isAdmin()){
			refuse(next,from,"Il faut être administrateur pour accéder à cette page.");
			return;
		}
	}
	
	if(to.meta.requiresUserOrMore){
		if(authenticationService.isCustomer()){
			refuse(next,from,"Les clients n'ont pas accès à cette page.");
			return;
		}
	}
	
	if (!authenticationService.isLogged()) {
		Vue.toasted.info("Veuillez vous connecter pour accéder à cette page.");
	    next({ name: 'login' });
	    return;
	 }
	 
  next();
});

function refuse(next,from, message){
	Vue.toasted.error("Accès interdit : "+message);
  if (from.name) {
    next(false);
  } else {
    next({ name: 'home' });
  }
}

export default router;

